import { render } from "./StartTicket.vue?vue&type=template&id=24287739"
import script from "./StartTicket.vue?vue&type=script&lang=js"
export * from "./StartTicket.vue?vue&type=script&lang=js"

import "./StartTicket.vue?vue&type=style&index=0&id=24287739&lang=scss"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__